
export default {
  data () {
    return {
      alternativeFilters: false
    }
  },
  mounted () {
    this.setMutationObserver()
  },
  beforeDestroy () {
    this.disconnectMutationObserver()
  },
  methods: {
    setMutationObserver () {
      const productsNode = document.getElementById('products')
      if (!productsNode) { return }

      this.observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
          const newValue = mutation.target.getAttribute(mutation.attributeName)
          this.$nextTick(() => {
            switch (mutation.attributeName) {
              case 'data-alternative-filters':
                this.alternativeFilters = newValue === 'true'
                break;
            }
          })
        }
      })

      this.observer.observe(productsNode, { attributes: true })
    },
    disconnectMutationObserver () {
      this.observer?.disconnect()
    }
  }
}
